import React, { useState } from 'react';
import { PDFDocument, rgb } from 'pdf-lib';

const PdfEditor = () => {
  const [pdfFile, setPdfFile] = useState(null);
  const [headerImage, setHeaderImage] = useState(null);
  const [footerImage, setFooterImage] = useState(null);

  const handlePdfUpload = (e) => {
    setPdfFile(e.target.files[0]);
  };

  const handleHeaderImageUpload = (e) => {
    setHeaderImage(e.target.files[0]);
  };

  const handleFooterImageUpload = (e) => {
    setFooterImage(e.target.files[0]);
  };

  const embedImage = async (pdfDoc, imageFile) => {
    const imageBytes = await imageFile.arrayBuffer();
    const imageType = imageFile.type;

    if (imageType === 'image/jpeg') {
      return pdfDoc.embedJpg(imageBytes);
    } else if (imageType === 'image/png') {
      return pdfDoc.embedPng(imageBytes);
    } else {
      throw new Error('Unsupported image type. Please upload a JPEG or PNG image.');
    }
  };

  const modifyPdf = async () => {
    if (!pdfFile || !headerImage || !footerImage) {
      alert('Please upload PDF, header image, and footer image.');
      return;
    }

    const pdfBytes = await pdfFile.arrayBuffer();
    const pdfDoc = await PDFDocument.load(pdfBytes);

    // Embed header and footer images based on their type
    const headerImageEmbed = await embedImage(pdfDoc, headerImage);
    const footerImageEmbed = await embedImage(pdfDoc, footerImage);

    const pages = pdfDoc.getPages();
    const headerImageDims = headerImageEmbed.scale(0.1); // Adjust scale as needed
    const footerImageDims = footerImageEmbed.scale(0.1); // Adjust scale as needed

    pages.forEach((page) => {
      const { width, height } = page.getSize();

      // Add header image to top of the page
      page.drawImage(headerImageEmbed, {
        x: width / 2 - headerImageDims.width / 2,
        y: height - headerImageDims.height - 10, // Adjust Y coordinate for spacing
        width: headerImageDims.width,
        height: headerImageDims.height,
      });

      // Add footer image to bottom of the page
      page.drawImage(footerImageEmbed, {
        x: width / 2 - footerImageDims.width / 2,
        y: 10, // Adjust Y coordinate for spacing
        width: footerImageDims.width,
        height: footerImageDims.height,
      });
    });

    const modifiedPdfBytes = await pdfDoc.save();

    // Create a Blob and download the modified PDF
    const blob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'modified.pdf';
    link.click();
  };

  return (
    <div>
      <h1>PDF Header and Footer Editor</h1>
      <input type="file" accept="application/pdf" onChange={handlePdfUpload} />
      <input type="file" accept="image/*" onChange={handleHeaderImageUpload} />
      <input type="file" accept="image/*" onChange={handleFooterImageUpload} />
      <button onClick={modifyPdf}>Add Header and Footer</button>
    </div>
  );
};

export default PdfEditor;
